import { queryOptions, useQuery } from '@tanstack/react-query'

import { communityApi } from '../api/communityApi'

export const communityQueryOptions = (id: number | null | undefined) =>
  queryOptions({
    queryKey: ['community', id],
    queryFn: ({ signal }) => {
      if (!id) throw new Error('Community id is required')
      return communityApi.getCommunity({ id }, { signal })
    },
    staleTime: 1000 * 60 * 2,
    enabled: !!id,
  })

export const useCommunityQuery = (id: number | null | undefined) => useQuery(communityQueryOptions(id))
